/* nukkad-ai-qv.js — 999 AI Quote Quick View
 * Triggered by "Get this →" on AI suggestion cards in Ask Gul.
 * Mirrors existing variantSheet design. Untouched: chip editor, slider, openEditor().
 */
(function () {
  'use strict';

  var HANDLE = 'nt-custom-quote-ai-pick';
  var _quote  = '';
  var _lines  = [];
  var _size   = 0;
  var _finish = 0;
  var _vList  = [];
  var _font   = { family: "'Amaranth', sans-serif", weight: '700' };

  /* ── Font detection: map quote sensibility → display font ────────────────
   * Uses only fonts already loaded by nukkad-slider.liquid (Google Fonts +
   * local Recoleta/Andalusia). All chosen weights are solid enough for
   * the engraving process — no hairlines, no ultra-heavies.
   */
  var FONT_RULES = [
    { re: /\b(funny|laugh|joke|roast|sarcas|silly|drama|humour|humor|goofy|chaos|chaos|quirk|fun)\b/i,
      family: "'Lobster', cursive",        weight: '400' },
    { re: /\b(thank|miss(ing)?|proud|believ|close|distance|quiet|love|heart|couldn.t say|long distance|you made)\b/i,
      family: "'Recoleta', serif",         weight: '600' },
    { re: /\b(first salary|promot|achiev|hustl|dream big|made it|still standing|strong|success|earn|salary|won|champion)\b/i,
      family: "'Montserrat', sans-serif",  weight: '900' },
    { re: /\b(soul|peace|bloom|rise|light|journey|begin|chapter|flow|calm|breath|serene|pooja|spiritual|gentle)\b/i,
      family: "'Pacifico', cursive",       weight: '400' },
    { re: /\b(wisdom|mentor|teacher|years|story|golden|classic|timeless|legacy|elder|dadi|nana|retire)\b/i,
      family: "'Playfair Display', serif", weight: '900' },
  ];

  function detectFont(q) {
    var text = (q || '').toLowerCase();
    for (var i = 0; i < FONT_RULES.length; i++) {
      if (FONT_RULES[i].re.test(text)) {
        return { family: FONT_RULES[i].family, weight: FONT_RULES[i].weight };
      }
    }
    return { family: "'Amaranth', sans-serif", weight: '700' };
  }

  /* ── Connector-aware quote splitter ──────────────────────────────────────
   * Connecting words (is, my, and, the…) are grouped together on one line.
   * Main words get their own line.
   * e.g. "THIRTY AND THRIVING"   → ["THIRTY", "AND", "THRIVING"]
   *      "love is my nature"     → ["love", "is my", "nature"]
   *      "dream big"             → ["dream", "big"]
   */
  var CONNECTORS = new Set([
    'and','or','but','is','are','was','were','be','been',
    'a','an','the','in','on','at','to','for','of',
    'my','your','our','its','by','from','with','as','so','yet','not'
  ]);

  function splitQuote(q) {
    var raw = (q || '').trim();
    // Explicit line breaks take priority
    var parts = raw.split(/\s*[\/\n]\s*/);
    if (parts.length >= 2 && parts.length <= 4) return parts.map(function (p) { return p.trim(); });

    var words = raw.split(/\s+/);
    if (words.length === 1) return [raw];
    if (words.length === 2) return [words[0], words[1]];

    // ≤5 words: connector-aware grouping
    if (words.length <= 5) {
      var lines = [], i = 0;
      while (i < words.length) {
        if (CONNECTORS.has(words[i].toLowerCase()) && i > 0 && i < words.length - 1) {
          // gather consecutive connectors into one line
          var grp = [];
          while (i < words.length && CONNECTORS.has(words[i].toLowerCase())) {
            grp.push(words[i++]);
          }
          lines.push(grp.join(' '));
        } else {
          lines.push(words[i++]);
        }
      }
      return lines.slice(0, 4);
    }

    // 6+ words: chunk by character length
    var out = [], cur = '';
    words.forEach(function (w) {
      var next = cur ? cur + ' ' + w : w;
      if (next.replace(/\s/g, '').length > 8 && cur) { out.push(cur); cur = w; }
      else cur = next;
    });
    if (cur) out.push(cur);
    return out.slice(0, 4);
  }

  /* ── Size formula ─────────────────────────────────────────────────────── */
  function calcSize(lines) {
    var bonus = [3, 2, 1, 0][Math.min(lines.length, 4) - 1];
    var longest = lines.reduce(function (m, l) {
      return Math.max(m, l.replace(/\s/g, '').length);
    }, 0);
    var maxSize = lines.length === 3 ? 8 : 9;
    return Math.min(maxSize, Math.max(6, longest + bonus));
  }

  /* ── Swatch helpers ───────────────────────────────────────────────────── */
  function lightText(color) {
    var m = color && color.match(/^#([0-9a-f]{3,6})$/i);
    if (m) {
      var hex = m[1].length === 3 ? m[1].split('').map(function (c) { return c + c; }).join('') : m[1];
      var r = parseInt(hex.slice(0,2),16), g = parseInt(hex.slice(2,4),16), b = parseInt(hex.slice(4,6),16);
      return (r*.299 + g*.587 + b*.114) < 150;
    }
    return false;
  }

  var FALLBACKS = [
    {name:'Natural Oak', hex:'#b8895a'}, {name:'Warm Teak',  hex:'#7c4b1e'},
    {name:'Walnut',      hex:'#4a2c0a'}, {name:'Espresso',   hex:'#5d4037'},
    {name:'Ivory',       hex:'#f5f0e8'}, {name:'Sage',       hex:'#558b2f'},
    {name:'Terracotta',  hex:'#bf5530'}, {name:'Charcoal',   hex:'#3a3a3a'}
  ];
  var COLOR_WORDS = window.NT_COLOR_MAP || {};

  function resolveHex(name, swatches, i) {
    if (swatches && swatches[name]) return swatches[name];
    var n = (name || '').toLowerCase();
    for (var w in COLOR_WORDS) { if (n.includes(w)) return COLOR_WORDS[w]; }
    var fb = FALLBACKS.find(function (f) {
      return f.name.toLowerCase() === n || n.includes(f.name.toLowerCase().split(' ').pop());
    });
    return fb ? fb.hex : FALLBACKS[i % FALLBACKS.length].hex;
  }

  /* ── Product fetch (variants + swatches) ─────────────────────────────── */
  var _cache = null;
  function loadProduct() {
    if (_cache) return Promise.resolve(_cache);
    return Promise.all([
      fetch('/products/' + HANDLE + '.json').then(function (r) { return r.json(); }).catch(function () { return null; }),
      fetch('/products/' + HANDLE + '?view=nt-swatches').then(function (r) { return r.text(); })
        .then(function (t) { try { return JSON.parse(t.trim()); } catch (e) { return {}; } }).catch(function () { return {}; })
    ]).then(function (res) {
      var d = res[0], sw = res[1];
      var swatches = (sw && sw.c) || {};
      var list = [];

      if (d && d.product && d.product.variants && d.product.variants.length) {
        var p = d.product;
        var opts = (p.options || []).map(function (o) { return (o && o.name) || String(o); });
        var colorIdx = opts.findIndex(function (o) {
          var n = (o || '').toLowerCase();
          return n.includes('color') || n.includes('colour') || n.includes('finish') ||
                 n.includes('shade') || n.includes('wood') || n.includes('material') || n.includes('texture');
        });
        var seen = new Set();
        p.variants.forEach(function (v, i) {
          var colorVal = colorIdx >= 0 ? (v['option' + (colorIdx + 1)] || v.option1 || v.title) : v.title;
          if (seen.has(colorVal)) return;
          seen.add(colorVal);
          var hex = resolveHex(colorVal, swatches, i);
          var txt = lightText(hex) ? '#f6ede1' : '#3a2b1d';
          list.push({ name: colorVal === 'Default Title' ? 'Standard' : colorVal, hex: hex, txt: txt, variantId: v.id, price: v.price });
        });
      }

      // Fall back to hardcoded finishes with first variant ID (or 0)
      if (!list.length) {
        var firstVid = (d && d.product && d.product.variants && d.product.variants[0] && d.product.variants[0].id) || 0;
        list = FALLBACKS.map(function (f) {
          return { name: f.name, hex: f.hex, txt: lightText(f.hex) ? '#f6ede1' : '#3a2b1d', variantId: firstVid };
        });
      }

      _cache = list;
      return list;
    });
  }

  /* ALL CAPS for single-word, sentence case for everything else */
  function applyCase(lines) {
    var totalWords = lines.join(' ').trim().split(/\s+/).length;
    if (totalWords <= 1) return lines.map(function (l) { return l.toUpperCase(); });
    var lower = lines.map(function (l) { return l.toLowerCase(); });
    // Capitalise first letter of entire quote (first non-empty line)
    for (var i = 0; i < lower.length; i++) {
      if (lower[i].length) { lower[i] = lower[i][0].toUpperCase() + lower[i].slice(1); break; }
    }
    return lower;
  }

  /* Darken a hex if it's too light to read on cream (#f5f0e8) background */
  function readableHex(hex) {
    var m = hex && hex.match(/^#([0-9a-f]{3,6})$/i);
    if (!m) return hex;
    var h = m[1].length === 3 ? m[1].split('').map(function(c){return c+c;}).join('') : m[1];
    var r = parseInt(h.slice(0,2),16), g = parseInt(h.slice(2,4),16), b = parseInt(h.slice(4,6),16);
    var lum = r*.299 + g*.587 + b*.114;
    if (lum < 160) return hex; // dark enough
    // Darken by 55% so light finishes (ivory, sage-light) still show their hue
    r = Math.round(r * 0.35); g = Math.round(g * 0.35); b = Math.round(b * 0.35);
    return '#' + [r,g,b].map(function(v){return ('0'+v.toString(16)).slice(-2);}).join('');
  }

  /* ── Render preview: cream bg, finish-colored text, sensibility font ─── */
  function renderPreview() {
    var f = _vList[_finish] || FALLBACKS[0];
    var span = document.getElementById('ntAiQVPreview');
    if (span) {
      span.style.color = readableHex(f.hex);
      span.style.fontFamily = _font.family;
      span.style.fontWeight = _font.weight;
      var display = applyCase(_lines);
      span.innerHTML = display.map(function (l) { return _esc(l); }).join('<br>');
    }
  }

  /* ── Render swatches ──────────────────────────────────────────────────── */
  function renderSwatches() {
    var wrap  = document.getElementById('ntAiQVSwatches');
    var label = document.getElementById('ntAiQVFinishName');
    if (!wrap) return;
    wrap.innerHTML = '';
    _vList.forEach(function (f, i) {
      var btn = document.createElement('button');
      btn.className = 'swatch' + (i === _finish ? ' on' : '');
      btn.style.background = f.hex;
      btn.title = f.name;
      btn.onclick = function () { _finish = i; renderSwatches(); renderPreview(); updateBtn(); };
      wrap.appendChild(btn);
    });
    if (label) label.textContent = (_vList[_finish] || {}).name || '';
    renderPreview();
    updateBtn();
  }

  function updateBtn() {
    var btn = document.getElementById('ntAiQVBtn');
    if (!btn || btn.disabled) return;
    var f = _vList[_finish];
    var p = f && f.price ? Math.round(parseFloat(f.price)) : 999;
    btn.textContent = 'Add to Cart — ₹' + p.toLocaleString('en-IN');
  }

  /* ── Open ─────────────────────────────────────────────────────────────── */
  window.ntAiQVOpen = function (quote) {
    _quote  = quote || '';
    _lines  = splitQuote(_quote);
    _size   = calcSize(_lines);
    _finish = 0;
    _font   = detectFont(_quote);

    // Size label
    var sizeEl = document.getElementById('ntAiQVSize');
    if (sizeEl) sizeEl.textContent = 'Size · ' + _size + ' inch';

    // Reset state
    var card = document.getElementById('ntAiQVCard');
    if (card) card.classList.remove('done');
    var btn = document.getElementById('ntAiQVBtn');
    if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart — ₹999'; }

    // Show initial preview in neutral ink — swatch color applied once finishes load
    var span = document.getElementById('ntAiQVPreview');
    if (span) {
      span.style.color = _cache ? readableHex((_cache[0]||FALLBACKS[0]).hex) : '#555';
      span.style.fontFamily = _font.family;
      span.style.fontWeight = _font.weight;
      var display = applyCase(_lines);
      span.innerHTML = display.map(function (l) { return _esc(l); }).join('<br>');
    }

    var prev = document.getElementById('ntAiQVPrev');
    if (prev) {
      prev.style.background = 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'20\' height=\'20\'%3E%3Cpath d=\'M20 0H0v20\' stroke=\'%238ca0be\' stroke-opacity=\'0.22\' stroke-width=\'0.5\' fill=\'none\'/%3E%3C/svg%3E") #f4f6f8';
    }
    var sw = document.getElementById('ntAiQVSwatches');
    if (sw) sw.innerHTML = '<span style="font-size:10px;color:var(--muted)">Loading finishes…</span>';

    // Open modal
    var modal = document.getElementById('ntAiQV');
    if (modal) modal.classList.add('open');

    // Fetch product swatches
    loadProduct().then(function (list) {
      _vList = list;
      renderSwatches();
    }).catch(function () {
      // Show fallback finishes even if product fetch fails — variantId will be 0
      _vList = FALLBACKS.map(function (f) {
        return { name: f.name, hex: f.hex, txt: lightText(f.hex) ? '#f6ede1' : '#3a2b1d', variantId: 0 };
      });
      renderSwatches();
    });
  };

  window.ntAiQVClose = function () {
    var modal = document.getElementById('ntAiQV');
    if (modal) modal.classList.remove('open');
  };

  /* ── Add to cart ──────────────────────────────────────────────────────── */
  window.ntAiQVAddToCart = function () {
    var f = _vList[_finish];
    if (!f || !f.variantId) {
      _toast('Please select a finish first, or make sure the product is published.');
      return;
    }
    var btn = document.getElementById('ntAiQVBtn');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: f.variantId,
          quantity: 1,
          properties: {
            'Quote'  : _lines.join(' / '),
            'Size'   : _size + ' inch',
            'Finish' : f.name,
            'Lines'  : String(_lines.length),
            'Font'   : _font.family.replace(/['"]/g, '').split(',')[0],
            '_source': 'gul-ai-999'
          }
        }]
      })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'HTTP ' + r.status); });
      return r.json();
    })
    .then(function () {
      ntAiQVClose();
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      }).catch(function () {}).finally(function () {
        var _sfHost = (typeof handleFloCartBtn === 'function') ? window :
                      (window.parent && window.parent !== window && typeof window.parent.handleFloCartBtn === 'function') ? window.parent : null;
        if (_sfHost) _sfHost.handleFloCartBtn();
      });
    })
    .catch(function (err) {
      if (btn) { btn.disabled = false; }
      updateBtn();
      _toast('Couldn\'t add — ' + ((err && err.message) || 'please try again'));
    });
  };

  window.ntAiQVCustomise = function () {
    ntAiQVClose();
    if (_quote) { try { sessionStorage.setItem('nt_landing_text', _quote); sessionStorage.setItem('nt_skip_welcome', '1'); } catch(e) {} }
    if (typeof ntOpenSlider === 'function') {
      ntOpenSlider('customise');
    }
  };

  function _toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function () { t.classList.remove('show'); }, 3000);
  }

  function _esc(str) {
    return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

})();
